export const getCheckoutSuccessPurchases = ({ checkoutSuccess }) => checkoutSuccess.purchases;

export const getCheckoutSuccessPurchasesStatus = ({ checkoutSuccess }) => checkoutSuccess.purchasesSideEffectStatus;
